import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { selectAssignmentHashKeys, unselectAssignmentHashKeys } from '@containers/upf-assign/upf-assign-actions';

import Checkbox from '@components/checkbox';
import { CHECKED, UNCHECKED, INDETERMINATE } from '@components/checkbox/constants';
import { getAssignmentHashKey, buildAssignmentHashKeys } from '@components/status-cell/helpers';

import { Root } from './styled';

const GridHeader = props => {
  const { sortedStudentIds, learningJourneyId } = props;

  const dispatch = useDispatch();

  const selectedAssignmentHashKeys = useSelector(state => state.UPFAssignReducer.selectedAssignmentHashKeys);

  const learningJourneyAssignmentHashKeys = sortedStudentIds.map(studentId =>
    getAssignmentHashKey(studentId, learningJourneyId)
  );

  const handleOnClick = checkboxState => {
    const isSelected = checkboxState === CHECKED;
    const assignmentHashKeys = buildAssignmentHashKeys({
      studentIds: sortedStudentIds,
      learningJourneyIds: [learningJourneyId]
    });

    if (isSelected) return dispatch(selectAssignmentHashKeys(assignmentHashKeys));

    return dispatch(unselectAssignmentHashKeys(assignmentHashKeys));
  };

  const getState = () => {
    const selectedAssignmentCount = learningJourneyAssignmentHashKeys.filter(
      assignmentHashKey => !!selectedAssignmentHashKeys[assignmentHashKey]
    ).length;
    const learningJourneyAssignmentCount = learningJourneyAssignmentHashKeys.length;

    if (selectedAssignmentCount === 0) return UNCHECKED;
    if (selectedAssignmentCount === learningJourneyAssignmentCount) return CHECKED;
    if (selectedAssignmentCount < learningJourneyAssignmentCount) return INDETERMINATE;

    return UNCHECKED;
  };

  return (
    <Root>
      <Checkbox checkboxHandler={handleOnClick} state={getState()} />
    </Root>
  );
};

GridHeader.propTypes = {
  learningJourneyId: PropTypes.number.isRequired,
  sortedStudentIds: PropTypes.array.isRequired
};

export default GridHeader;



// WEBPACK FOOTER //
// ./components/grid/grid-header/index.js